import Box from "ds/components/Box";
import FormField from "ds/components/Form/Field";
import Link from "ds/components/Link";
import Typography from "ds/components/Typography";
import { AuditTrailEntry } from "types/generated";

import styles from "./styles.module.css";

type StackDependencyDetailsProps = {
  item: AuditTrailEntry;
};

const StackDependencyDetails = ({ item }: StackDependencyDetailsProps) => {
  const metadata = item.affectedResource?.metadata;

  if (metadata?.__typename !== "AuditTrailStackDependencyMetadata") return null;

  const { stackName, stackId, dependsOnStackName, dependsOnStackId } = metadata;

  return (
    <Box direction="column" gap="large" className={styles.dependencySection}>
      <Typography tag="p" variant="p-t5">
        Dependency details
      </Typography>

      <FormField label="Direction" align="start">
        <Box direction="row" align="center" gap="small" wrap>
          <Link href={`/stack/${stackId}`}>{stackName}</Link>
          <Typography tag="span" variant="p-body2">
            depends on
          </Typography>
          <Link href={`/stack/${dependsOnStackId}`}>{dependsOnStackName}</Link>
        </Box>
      </FormField>
    </Box>
  );
};

export default StackDependencyDetails;
